import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { persistor } from '../store';
import { selectCurrentUser } from 'slice/authSlice';
import { isAuthorized } from 'utils/userUtils';
import { api } from 'services/api';

/**
 * Hook used to handle current user.
 * @returns {{isAuthorized: function(*, *): *, user: unknown}}
 */
export const useAuth = () => {
  const user = useSelector(selectCurrentUser);
  const dispatch = useDispatch();

  const currentUser = useMemo(
    () => ({
      user,
      isAuthorized: (functionality, operation) => isAuthorized(user, functionality, operation)
    }),
    [user]
  );

  const logout = () => {
    persistor.purge();
    dispatch(api.util.resetApiState());
    window.location.assign(
      `${window.location.href.substring(0, window.location.href.indexOf('#') + 1)}/signIn`
    );
    window.location.reload();
  };

  return { currentUser, logout };
};
